import React from 'react';
import { coreAdminApiBalanceApi } from '../api';
import { StatItem } from './statItem';
import { Price } from './price';

export const ApiBalance: React.FC = () => {
  const { data, isLoading } = coreAdminApiBalanceApi.endpoints.getApiBalance.useQuery();
  return <StatItem isLoading={isLoading} label="api kei" title="Текущий баланс API" value={<Price currency="$" value={data?.apikei} />} />;
};
